import Icon from "@lib/common/components/Icon/Icon";
import { ActionIcon } from "@mantine/core";

export default function Thumb({
  type,
  selected,
  disabled,
  onClick
}: {
  type: "thumbsUp" | "thumbsDown";
  selected: boolean;
  disabled: boolean;
  onClick: VoidFunction;
}) {
  return (
    <ActionIcon variant="subtle" disabled={disabled} onClick={onClick}>
      <Icon
        name={type === "thumbsUp" ? "thumbs-up" : "thumbs-down"}
        size="0.9rem"
        variant={selected ? "solid" : "regular"}
        color={selected ? "var(--mantine-primary-color-filled)" : undefined}
        style={type === "thumbsDown" ? { transform: "scaleX(-1)" } : undefined} // Flip horizontally so thumbs face each other.
      />
    </ActionIcon>
  );
}
